import { render, staticRenderFns } from "./CallLift.vue?vue&type=template&id=0acfaa64&scoped=true"
import script from "./CallLift.vue?vue&type=script&lang=js"
export * from "./CallLift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acfaa64",
  null
  
)

export default component.exports